import React from 'react'

export const UserContext = React.createContext({
  user: { username: "Guest", course: "all_topics" },
  setUser: () => {}
})
